module.exports = __webpack_public_path__ + "media/images/banner/tjt/pc/travel03_770_280_en-3358a203d3cd05743b022f92f5d45d76.jpg";